import _ from "lodash";
import React, { Component } from "react";
import { connect } from "react-redux";
import { ModalDialog, Modal } from "react-bootstrap";
// import TemplateEditor from "./grape";
import { BaseComponent, LABEL_POSITION_TOP } from "BaseComponent";
import Button from "react-bootstrap-button-loader";
import Iframe from "react-iframe";
import GrapesmodalContent from "./grapesmodal";
import LocaleStrings from "Languages";
import { Field, reduxForm, reset } from "redux-form";
import { showError, showSuccess } from "ReduxErrorBar";
import { COMMON_FAIL_MESSAGE } from "Constants";
// import "grapesjs/dist/css/grapes.min.css";
import { saveTitleandurl } from "../../actions";

class ModalContent extends Component {
  constructor(props) {
    super(props);
    this.state = { isOpen: false, id: 0 };
    this.onSubmitForm = this.onSubmitForm.bind(this);
    this.state = { loading: false, showModal: false };
  }

  openModals = (pageid) => this.setState({ isOpen: true, id: pageid });
  closeModals = () => this.setState({ isOpen: false });

  openModal = () => {
    this.props.reset();
    this.setState({ loading: false, showModal: true });
  };

  closeModal = () => {
    this.props.reset();
    this.setState({ showModal: false });
  };

  onSubmitForm(values) {
    values.pagetitle = values.pagetitle.trim();
    values.pageurl = values.pageurl.trim();

    this.setState({ loading: true });
    this.props.saveTitleandurl(this.props.session, values, (response) => {
      if (response.success === 0) {
        this.setState({ loading: false });
        this.props.showError(COMMON_FAIL_MESSAGE);
      } else {
        let id = response.result.resource[0].id;

        this.setState({ loading: false });
        // this.props.showSuccess(LocaleStrings.polls_qa_message_qa_added_seccess);
        this.props.showSuccess(LocaleStrings.showsuccess_modal_savemessage);
        this.openModals(id);
        // this.closeModal();
      }
    });
  }

  render() {
    var { handleSubmit, pristine, invalid, reset, submitting } = this.props;

    return (
      <div>
        <span className="pull-right">
          <button
            type="button"
            className="btn btn-custom-blue"
            onClick={this.openModal}
          >
            {/* <i className="fa fa-plus i-custom-m"></i>{LocaleStrings.polls_qa_text_add_qa} */}
            <img
              style={{ paddingRight: 8, paddingBottom: 3 }}
              src="../../style/images/header-icons/plus.png"
            ></img>
            New Page
          </button>
        </span>
        {/* <Modal show={this.props.isOpen} onHide={this.props.onClose}> */}
        <Modal
          className="modal-container"
          show={this.state.showModal === true ? true : false}
          onHide={this.closeModal}
          animation={true}
        >
          <form
            onSubmit={handleSubmit(this.onSubmitForm)}
            encType="multipart/form-data"
          >
            <Modal.Header>
              <div className="import-modal-title">Web Template</div>
              <button
                type="button"
                className="i-custom-cross-popup pull-right"
                onClick={this.closeModal}
              >
                <img
                  className="i-custom-small"
                  src="../../style/images/custom-icons/cross-black.png"
                />
              </button>
            </Modal.Header>
            <Modal.Body>
              <TitleUrl {...this.props} />
            </Modal.Body>
            <Modal.Footer>
              {/* <Button
                className="btn-custom-blue ml-10"
                
                loading={this.state.loading}
                disabled={pristine || invalid || submitting}
                type="submit"
              >
                {LocaleStrings.button_save}
              </Button> */}
              <Button
                className="btn-custom-blue schedule-add-button"
                // onClick={this.openModals}
                loading={this.state.loading}
                disabled={pristine || invalid || submitting}
                type="submit"
              >
                Save & Edit
              </Button>
              {this.state.isOpen ? (
                <GrapesmodalContent
                  // pageid={this.setState.id}
                  pageid={this.state.id}
                  isOpen={this.state.isOpen}
                  onClose={this.closeModals}
                />
              ) : (
                ""
              )}

              {/* <Button variant="secondary" onClick={this.onClose}>
              Close
            </Button> */}
              <Button
                className="btn btn-custom-white"
                onClick={this.closeModal}
              >
                {LocaleStrings.button_close}
              </Button>
            </Modal.Footer>
          </form>
        </Modal>
      </div>
    );
  }
}

function mapStateToProps(state) {
  let initVals = {};

  return {
    session: state.session,
    initialValues: initVals,
  };
}

function validate(values) {
  var errors = {};
  var pagetitle = values["pagetitle"];
  var pageurl = values["pageurl"];

  if (!pagetitle || pagetitle.trim() === "") {
    errors["pagetitle"] = LocaleStrings.required;
  }
  if (!pageurl || pageurl.trim() === "") {
    errors["pageurl"] = LocaleStrings.required;
  }

  return errors;
}

export default connect(mapStateToProps, {
  saveTitleandurl,
  showError,
  showSuccess,
})(
  reduxForm({
    validate,
    form: "WEBPageForm",
    keepDirtyOnReinitialize: true,
    enableReinitialize: true,
  })(ModalContent)
);

class TitleUrl extends BaseComponent {
  render() {
    return (
      <div className="basicform">
        <Field
          name="pagetitle"
          label={LocaleStrings.new_page_title}
          placeholder={LocaleStrings.new_page_title_placeholder}
          type="text"
          component={this.renderFieldText}
          mandatory="true"
          labelposition={LABEL_POSITION_TOP}
        />
        <Field
          name="pageurl"
          label={LocaleStrings.new_page_url}
          placeholder={LocaleStrings.new_page_url_placeholder}
          type="text"
          component={this.renderFieldText}
          mandatory="true"
          labelposition={LABEL_POSITION_TOP}
        />
      </div>
    );
  }
}
